import { pickImageModel } from './imageModelCatalog';
import {
  estimateCredits,
  getVideoModelById,
  rateForGeneratedAudio,
  requiresDrivingAudio,
  resolveResolution,
  supportsGeneratedAudio,
} from './videoModelCatalog';

/** Same tariff the remix edge charges: model, duration, resolution, audio (+ stages when on). */
export function quoteTemplateCredits(template: {
  video_model_id: string;
  resolution_id: string;
  duration_seconds: number;
  generate_audio: boolean;
  enable_stages?: boolean;
  stage_count?: number;
  image_model_id?: string | null;
}): number | null {
  const model = getVideoModelById(template.video_model_id);
  if (!model || requiresDrivingAudio(model)) return null;
  if (!model.modalities.includes('t2v') && !model.modalities.includes('i2v')) return null;
  try {
    const resolution = resolveResolution(model, template.resolution_id);
    const wantAudio = Boolean(template.generate_audio) && supportsGeneratedAudio(model);
    const rate = rateForGeneratedAudio(resolution, wantAudio);
    const video = estimateCredits({
      creditsPerSecond: rate.creditsPerSecond,
      durationSeconds: template.duration_seconds,
    });
    if (!template.enable_stages) return video;
    const stageCount = Math.max(2, Math.min(12, Math.round(Number(template.stage_count) || 7)));
    const image = pickImageModel(template.image_model_id || undefined);
    return video + image.creditsPerImage * stageCount;
  } catch {
    return null;
  }
}
